import { a as SET_PAGE_NAME_VAR, P as PageName } from './index2.js';

/**
 * **HNS V6 dataLayer**
 *
 * @exports bs_310
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  const isBigMamaHotelsBePages = window.location.pathname.match(/buchen/) && thn.data.accountUserId === 1048070;

  /**
     *
     * @memberOf module:bs_310
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {
    const container = document.body;
    const dataLayer = window.dataLayer;

    if (container) {
      const checker = thn.debounce(() => {
        thn.languageCheck();
        thn.pageCheck();
      }, 600);
      thn.observeDom(container, checker, {
        attributes: true,
      });

      thn.shutdown(() => {
        checker.cancel();
        thn.stopObserveDom(container, checker);
      });
    }

    if (!dataLayer) {
      return;
    }

    const checkUserRegPageByDl = new thn.DataLayerHelper(dataLayer, (_model, message) => {
      if (message.event === 'thnUrpVisited') {
        window[SET_PAGE_NAME_VAR] = PageName.UserRegisterPage;
        thn.pageCheck();
      }
    }, true);

    thn.shutdown(() => {
      checkUserRegPageByDl.cancel();
    });

  };
  /**
     * @memberOf module:bs_310
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      let lang;
      const isBookingEngine = window.location.hostname.match(/onepagebooking/);

      if (isBookingEngine || isBigMamaHotelsBePages) {
        lang = document.documentElement.lang;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      // Big Mama
      if (thn.data.accountUserId === 1048070) {
        lang = document.querySelector('.langNav .current')?.textContent ?? 'fr';
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      // Hotel Galantha Eisenstadt
      if (thn.data.propertyId === 1051306) {
        lang = document.querySelector('.language-switch.lang-active')?.textContent;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }
      // Aletto hotels
      if (thn.data.accountUserId === 1046802) {
        lang = document.querySelector('.selector-lng.w--current')?.textContent;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      // Luitpoldpark Hotel
      if (thn.data.propertyId === 1033509) {
        const bodyClassList = document.body.classList;
        lang = !thn.empty(bodyClassList) && Array.from(bodyClassList).slice(3, 4)[0];
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      // ADEA Lifestyle Suites
      if (thn.data.propertyId === 1158653) {
        lang = document.querySelector('.DNA-section__lang-menu__item--act')?.textContent?.trim();
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      // Alpenhof Murnau
      if (thn.data.propertyId === 1036595) {
        lang = window.location.pathname.split('/')?.[1];
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
        } else {
          resolve('de');
        }
        return;
      }

      // KOOS Hotel München - Homepage
      if (!isBookingEngine && thn.data.propertyId === 1160829) {
        lang = document.querySelector('.wpml-ls-current-language span')?.textContent;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      reject('no_language');
    });
  };

  /**
   * @memberOf module:bs_310
   * @see {@link generate_search_url}
   *
   * @param {object} ctx - The context object.
   */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/buchen/) || url.hostname.match(/onepagebooking/);
    // Original Url: https://buchen.parkhotelsellin.de/buchen/?_gl=1*v7b8mw*_ga*MTQ3NTcxMTMuMTY3ODE5MTI1Nw..*_ga_H4Z504Q3L0*MTY3ODE5MTI1Ni4xLjAuMTY3ODE5MTI1Ni4wLjAuMA
    // New Url: https://buchen.parkhotelsellin.de/buchen/?arrival=[date_begin]&departure=[date_end]&lang=[language]&filter=true
    // https://www.ahorn-hotels.de/buchen/templin/?filter=true&arrival=27.06.2025&departure=28.06.2025&rooms=2&adults=4&children=3&ages=2,4,12&lang=en&currencyCode=EUR

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    url.searchParams.delete('_gl');
    url.searchParams.set('arrival', '[date_begin]');
    url.searchParams.set('departure', '[date_end]');
    url.searchParams.set('lang', '[language]');
    url.searchParams.set('filter', 'true');
    url.searchParams.set('rooms', ctx.data?.roomsDispo?.length || 1);
    url.searchParams.set('adults', '[adults]');
    url.searchParams.set('children', '[children]');
    const allChildrenAges = [];
    if (ctx.data.roomsDispo) {
      ctx.data.roomsDispo.forEach((room) => {
        if (room.childrenAges.length > 0) {
          allChildrenAges.push(...room.childrenAges);
        }
      });
    }
    url.searchParams.set('ages', allChildrenAges?.join(',') || '');
    url.searchParams.set('currencyCode', '[currency]');
    ctx.newData.dateBegin = ctx.data.dateBegin.replace(/\//g, '.');
    ctx.newData.dateEnd = ctx.data.dateEnd.replace(/\//g, '.');

    ctx.newUrl = url.toString();

    return ctx;
  };

  return engine;

}

export { factory };
